import React, { PropsWithChildren } from 'react'
import { MobileLoginOptionsProvider } from '@providers/mobile-login-options'
import { MobileMenuProvider } from '@providers/mobile-popup-menu'
import { notice } from '@shared/components/notice'
import { TopMenu } from '@shared/components/top-menu'
import { FixedMenu } from '@shared/components/top-menu/fixed'

import { PageLayoutShotApplicationProps } from './model'
import { SignFooter } from './sign-footer'

import styles from './style.module.scss'

export const View = ({
	children,
	menuProps,
	hasError,
}: PropsWithChildren<PageLayoutShotApplicationProps>) => {
	if (hasError) {
		notice({
			title: 'Ошибка',
			message:
				'Для подписания документов необходимо включить Cookie в вашем браузере. Обратитесь к менеджеру, чтобы решить проблему.',
			type: 'error',
		})
	}

	return (
		<MobileMenuProvider>
			<MobileLoginOptionsProvider>
				<div className={styles.wrapper}>
					<TopMenu {...menuProps} isLogoHidden content={<></>} />
					<FixedMenu {...menuProps} isLogoHidden content={<></>} />
					<main className={styles.content}>{children}</main>
					<SignFooter />
				</div>
			</MobileLoginOptionsProvider>
		</MobileMenuProvider>
	)
}
